export class GlobalMessageHandler {
    constructor() {
        this.messages = [];
        this.container = {};
        this.containerWrapper = undefined;
    }
    add(GlobalMessageObj) {
        this.messages.push(GlobalMessageObj);
    }
    show(GlobalMessageObj) {
        this.add(GlobalMessageObj);
        this.render();
    }
    render() {
        while (this.messages.length > 0) {
            const message = this.messages.pop();
            this.renderByType(message.type, message);
        }
    }
    renderByType(type, message) {
        if (typeof this.containerWrapper === 'undefined') {
            this.containerWrapper = document.createElement('div');
            this.containerWrapper.classList.add('message-container-wrapper');
            document.body.insertAdjacentElement('afterbegin', this.containerWrapper);
        }
        if (typeof this.container[type] === 'undefined') {
            this.container[type] = document.createElement('div');
            this.container[type].classList.add('message-container');
            this.container[type].classList.add('message-container--' + type);
            this.containerWrapper.appendChild(this.container[type]);
        }
        const containerElement = document.createElement('div');
        containerElement.classList.add('message-container__row');
        const hasTitle = message.title && message.title.length > 0;
        let titleElement;
        if (hasTitle) {
            titleElement = document.createElement('span');
            titleElement.classList.add('message-container__row__title');
            titleElement.innerText = message.title;
        }
        let introIcon = 'fa-check-circle';
        if (type === 'error') {
            introIcon = 'fa-exclamation-circle';
        }
        else if (type === 'info') {
            introIcon = 'fa-info-circle';
        }
        const introElement = document.createElement('span');
        introElement.classList.add('fa');
        introElement.classList.add(introIcon);
        const messageElement = document.createElement('span');
        messageElement.classList.add('message-container__row__message');
        messageElement.innerText = message.message;
        const closeElement = document.createElement('span');
        closeElement.classList.add('message-container--closer');
        closeElement.classList.add('fa');
        closeElement.classList.add('fa-times');
        closeElement.addEventListener('click', () => {
            this.removeContainer(this.container[type], containerElement);
        });
        containerElement.appendChild(introElement);
        if (hasTitle) {
            containerElement.appendChild(titleElement);
        }
        containerElement.appendChild(messageElement);
        containerElement.appendChild(closeElement);
        this.container[type].appendChild(containerElement);
        setInterval(() => {
            this.removeContainer(this.container[type], containerElement);
        }, 150000);
    }
    removeContainer(container, containerElement) {
        containerElement.addEventListener('webkitAnimationEnd', () => {
            container.removeChild(containerElement);
        });
        containerElement.addEventListener('animationend', () => {
            container.removeChild(containerElement);
        });
        containerElement.classList.add('message-container__row--remove');
    }
}
window.GMS = new GlobalMessageHandler();
